import SlimSelect from 'slim-select'
import 'slim-select/styles' 
document.addEventListener('DOMContentLoaded', () => {


const commonSettings = {
    showSearch:false,
     placeholderText: 'Выберите',
   }

const selectors = [
// { selector: 'select[name="dealer"]', settings: { placeholderText: 'Дилер' } },
{ selector: 'select[name="dealer"]'},
{ selector: 'select[name="car"]'},
{ selector: 'select[name="job"]'},
]



  selectors.forEach(({ selector, settings = {} }) => {
    const element = document.querySelector(selector);
    if (element) {

    new SlimSelect({
  select: element,
  settings:{ 
    ...commonSettings,
    ...settings 
  }

})
    
    }
  });




});